module.exports = __webpack_public_path__ + "static/media/finish.b444f972.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/finish.svg
// module id = 321
// module chunks = 0